import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      // 行政机构管理
      path: '/',
      name: 'Administration',
      meta: {
        menu: '/'
      },
      component: resolve => require(['@/pages/administration'], resolve),
    },
    // 新增行政机构
    {
      path: '/addOrganization',
      name: 'AddOrganization',
      meta: {
        menu: '/'
      },
      component: resolve => require(['@/pages/administration/add'], resolve),
    },
    // 行政机构详情
    {
      path: '/organizationDetails/:branchId',
      name: 'OrganizationDetails',
      meta: {
        menu: '/'
      },
      component: resolve => require(['@/pages/administration/detail'], resolve)
    },
    // 编辑行政机构
    {
      path: '/editOrganization/:branchId',
      name: 'EditOrganization',
      meta: {
        menu: '/'
      },
      component: resolve => require(['@/pages/administration/edit'], resolve),
    },
    //  个代机构管理
    {
      path: '/agencyManagement',
      name: 'AgencyManagement',
      meta: {
        menu: '/agencyManagement'
      },
      component: resolve => require(['@/pages/agencyManagement'], resolve),
    },
    // 新增个代机构     -------------- 新增----------------
    {
      path: '/addAgency',
      name: 'addAgency',
      meta: {
        menu: '/agencyManagement'
      },
      component: resolve => require(['@/pages/agencyManagement/add'], resolve),
    },
    // 个代机构详情     -------------- 新增----------------
    {
      path: '/agencyDetail/:branchId',
      name: 'agencyDetail',
      meta: {
        menu: '/agencyManagement'
      },
      component: resolve => require(['@/pages/agencyManagement/detail'], resolve)
    },
    // 编辑个代机构       -------------- 新增----------------
    {
      path: '/editAgency/:branchId',
      name: 'editAgency',
      meta: {
        menu: '/agencyManagement'
      },
      component: resolve => require(['@/pages/agencyManagement/edit'], resolve),
    },
    {
      // 银保机构管理                 -----------/bancassuranceArganization改成/bankOrganization-----------------
      path: '/bankOrganization',
      name: 'bankOrganization',
      meta: {
        menu: '/bankOrganization'
      },
      component: resolve => require(['@/pages/bankOrganization'], resolve),
    },
    // 新增银保机构     -------------- 新增----------------
    {
      path: '/addBankOrganization',
      name: 'addBankOrganization',
      meta: {
        menu: '/bankOrganization'
      },
      component: resolve => require(['@/pages/bankOrganization/add'], resolve),
    },
    // 银保机构详情     -------------- 新增----------------
    {
      path: '/bankOrganizationDetail/:branchId',
      name: 'bankOrganizationDetail',
      meta: {
        menu: '/bankOrganization'
      },
      component: resolve => require(['@/pages/bankOrganization/detail'], resolve)
    },
    // 编辑银保机构       -------------- 新增----------------
    {
      path: '/editBankOrganization/:branchId',
      name: 'editBankOrganization',
      meta: {
        menu: '/bankOrganization'
      },
      component: resolve => require(['@/pages/bankOrganization/edit'], resolve),
    },
    // 网点渠道管理
    {
      path: '/networkManagemen',
      name: 'NetworkManagemen',
      meta: {
        menu: '/networkManagemen'
      },
      component: resolve => require(['@/pages/networkManagemen'], resolve),
    },
    // 新增网点渠道     -------------- 新增----------------
    {
      path: '/addNetwork',
      name: 'addNetwork',
      meta: {
        menu: '/networkManagemen'
      },
      component: resolve => require(['@/pages/networkManagemen/add'], resolve),
    },
    // 网点渠道详情     -------------- 新增----------------
    {
      path: '/networkDetail/:branchId',
      name: 'networkDetail',
      meta: {
        menu: '/networkManagemen'
      },
      component: resolve => require(['@/pages/networkManagemen/detail'], resolve)
    },
    // 编辑网点渠道       -------------- 新增----------------
    {
      path: '/editNetwork/:branchId',
      name: 'editNetwork',
      meta: {
        menu: '/networkManagemen'
      },
      component: resolve => require(['@/pages/networkManagemen/edit'], resolve),
    },
    // 用户管理
    {
      path: '/userManage',       // /usermManagement修改成/userManage
      name: 'userManage',
      meta: {
        menu: '/userManage'
      },
      component: resolve => require(['@/pages/userManage'], resolve),
    },
    // 添加用户
    {
      path: '/addUser',
      name: 'AddUser',
      meta: {
        menu: '/userManage'
      },
      component: resolve => require(['@/pages/userManage/add'], resolve),
    },
    // 用户列表
    {
      path: '/userList/:branchId',      // /usermManagementDetails/:branchId改成/userList/:branchId
      name: 'userList',
      meta: {
        menu: '/userManage',
        keep: true   // 缓存
      },
      component: resolve => require(['@/pages/userManage/userList'], resolve),
    },
    // 用户详情
    {
      path: '/userInfo/:employeId',
      name: 'UserInfo',
      meta: {
        menu: '/userManage'
      },
      component: resolve => require(['@/pages/userManage/detail'], resolve),
    },
    // 用户编辑         -------------- 新增----------------
    {
      path: '/editUser/:employeId',
      name: 'editUser',
      meta: {
        menu: '/userManage'
      },
      component: resolve => require(['@/pages/userManage/edit'], resolve),
    },
    // 角色管理
    {
      path: '/roleManagement',
      name: 'RoleManagement',
      meta: {
        menu: '/roleManagement',
        keep: true   // 缓存
      },
      component: resolve => require(['@/pages/roleManagement'], resolve),
    },
    // 添加角色
    {
      path: '/addRoleManagement',
      name: 'AddRoleManagement',
      meta: {
        menu: '/roleManagement'
      },
      component: resolve => require(['@/pages/roleManagement/add'], resolve),
    },
    // 角色详情
    {
      path: '/roleManagementDetails/:roleId',    // -------/roleManagementDetails/:branchId改成/roleManagementDetails/:roleId
      name: 'RoleManagementDetails',
      meta: {
        menu: '/roleManagement'
      },
      component: resolve => require(['@/pages/roleManagement/detail'], resolve),
    },
    // 编辑角色
    {
      path: '/roleManagementEdit/:roleId',    // -----新增
      name: 'roleManagementEdit',
      meta: {
        menu: '/roleManagement'
      },
      component: resolve => require(['@/pages/roleManagement/edit'], resolve),
    },
    // 日志管理
    {
      path: '/operationLogManagement',
      name: 'RperationLogManagement',
      meta: {
        menu: '/operationLogManagement',
        keep: true   // 缓存
      },
      component: resolve => require(['@/pages/operationLogManagement'], resolve),
    },
    // 系统报表 - 用户权限
    {
      path: '/UserRole',
      name: 'UserRole',
      meta: {
        menu: '/UserRole',
        keep: true   // 缓存
      },
      component: resolve => require(['@/pages/userRole'], resolve),
    },
    // 系统报表 - 角色权限
    {
      path: '/Role',
      name: 'Role',
      meta: {
        menu: '/Role',
      },
      component: resolve => require(['@/pages/role'], resolve),
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js